<mat-toolbar color="primary" class="navbar" *ngIf="isUserLoggedIn">
  <!-- <button mat-icon-button (click)="toggleSidebar()" style="color: white;" matTooltip="{{ 'MENU' | translate }}">
    <mat-icon>menu</mat-icon>
  </button> -->
  <img src="../assets/img/LogoBN.png" style="margin-right: 10px; cursor: pointer;" width="150" (click)="navigateToDashboard()">
  <a (click)="navigateToDashboard()" class="no-style">
    <span class="white-color title">| {{ 'TITLE' | translate }}</span>
  </a>

  <span class="spacer"></span>

  <!-- Selector de idioma -->
  <mat-form-field class="language-select" matTooltip="{{ 'LANGUAGE' | translate }}">
    <mat-select [(value)]="translate.currentLang" (selectionChange)="changeLanguage($event.value)">
      <mat-option value="en">English</mat-option>
      <mat-option value="es">Español</mat-option>
      <mat-option value="pt-BR">Português</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Datos del usuario -->
  <span class="white-color user-label">
    {{ 'USER' | translate }}: {{ userInfo?.userName }}
  </span>

  <!-- Botón de logout -->
  <button mat-icon-button (click)="logout()" matTooltip="{{ 'LOGOUT' | translate }}">
    <mat-icon class="white-color">logout</mat-icon>
  </button>
</mat-toolbar>

<mat-sidenav-container class="sidenav-container">
  <!-- Sidebar -->
  <!-- <mat-sidenav #sidenav mode="side" [(opened)]="isSidebarOpen" class="sidenav">
    <mat-nav-list>
      <a mat-list-item routerLink="/dashboard" routerLinkActive="active">
        <mat-icon>dashboard</mat-icon>
        {{ 'DASHBOARD' | translate }}
      </a>

      <a mat-list-item routerLink="/reports" routerLinkActive="active">
        <mat-icon>library_books</mat-icon>
        {{ 'REPORTS' | translate }}
      </a>
    </mat-nav-list>
  </mat-sidenav> -->

  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
